<template>
  <v-row
    v-bind="settings"
    v-on="listeners"
  >
    <slot></slot>
  </v-row>
</template>

<script>
export default {
  name: "SGPRowComponent",
  computed: {
    settings () {
      return {
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    },
  }
}
</script>